// extracted by mini-css-extract-plugin
export var MozOsxFontSmoothing = "grayscale";
export var WebkitFontSmoothing = "antialiased";
export var divider = "Dropdown-module--divider--e71c7";
export var fontFamily = "IvarDisplay-Medium,serif";
export var fontSize = "1.5rem";
export var fontStretch = "normal";
export var fontStyle = "normal";
export var fontWeight = "normal";
export var grey = "var(--grey-4)";
export var group = "Dropdown-module--group--2eb39";
export var groupLabel = "Dropdown-module--groupLabel--d989b";
export var lineHeight = "1.75rem";
export var menu = "Dropdown-module--menu--69998";
export var option = "Dropdown-module--option--8cc48";
export var optionLabel = "Dropdown-module--optionLabel--f61ab";
export var optionSelectedColor = "var(--stroke-05)";
export var select = "Dropdown-module--select--6123d";
export var stroke = "var(--stroke-1)";
export var white = "var(--white)";